module.exports = __webpack_public_path__ + "img/compre-confie.png";